import { render, staticRenderFns } from "./workTypeList.vue?vue&type=template&id=437401c6&"
import script from "./workTypeList.vue?vue&type=script&lang=js&"
export * from "./workTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports